<template>
    <!-- <v-navigation-drawer v-model="inputValue" app color="grey darken-2" dark floating persistent width="260"> -->
        <v-navigation-drawer v-model="inputValue" src="https://demos.creative-tim.com/vue-material-dashboard/img/sidebar-2.32103624.jpg" app color="grey darken-2" dark floating persistent width="260">
        <template v-slot:img="attrs">
            <v-img v-bind="attrs" gradient="to top, rgba(0, 0, 0, .7), rgba(0, 0, 0, .7)"/>
        </template>

        <v-list-item two-line>
            <v-list-item-avatar color="white">
                <v-img src="../../../public/image/logo-normal.png" height="34" contain/>
            </v-list-item-avatar>

            <v-list-item-title class="title">ARTILUX</v-list-item-title>
        </v-list-item>

        <v-divider class="mx-3 mb-3" />

        <v-list nav>
            <!-- Bug in Vuetify for first child of v-list not receiving proper border-radius -->
            <!-- <div /> -->

            <v-list-item v-for="(link, i) in links" :key="i" :to="link.to" active-class="primary white--text">
                <v-list-item-action>
                  <v-icon>{{ link.icon }}</v-icon>
                </v-list-item-action>

                <v-list-item-title v-text="link.text" />
            </v-list-item>
        </v-list>

    </v-navigation-drawer>
</template>

<script>
    import {
        mapMutations,
        mapState
    } from 'vuex'

export default {
    props: {
        opened: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        links: [
            {
                to: '/account_overview',
                icon: 'mdi-account',
                text: 'Account Management'
            },
            {
                to: '/login_overview',
                icon: 'mdi-calendar-account-outline',
                text: 'Login information'
            },
            {
                to: '/params_overview',
                icon: 'mdi-text-box-search-outline',
                text: 'Query log'
            },
            {
                to: '/sensor_model_overview',
                icon: 'mdi-file-cog-outline',
                text: 'Sensor Modeling'
            },
            
        ]
    }),

    computed: {
        inputValue: {
            get () {
                return this.$store.getters.drawer
            },
            set (val) {
                this.$store.commit('setDrawer', val)
            }
        },
    },

    methods: {
    }

   
}
</script>
